import { authHeaders, fetchWithAuthRetry, getApiUrl, parseApiError, type PaginationMeta } from './common';
import type { AgentConfig } from './agentConfigs';
import type { ConventionListItem } from './conventions';
import type { Daemon, DaemonTrigger, DaemonListResult, SharedDaemon } from './daemon';
import type { HeartbeatData } from './heartbeat';
import type { MergedRunnerModelsByType, RunnerModelsByType } from './runnerModels';

/**
 * 러너 요청 모달 콜드 오픈 시 필요한 8개 소스를 한 번에 반환하는 부트스트랩 응답.
 * 각 필드는 대응하는 개별 엔드포인트와 동일한 shape이라, 프론트에서 개별 React Query
 * 캐시 키에 그대로 하이드레이트할 수 있다.
 */
export type RunnerRequestBootstrap = Omit<DaemonListResult, 'daemons'> & {
  daemons: Daemon[];
  sharedDaemons: SharedDaemon[];
  publicRunnerModels: RunnerModelsByType;
  mergedRunnerModels: MergedRunnerModelsByType;
  runnerModelCatalogs: Record<string, MergedRunnerModelsByType>;
  agentConfigs: AgentConfig[];
  heartbeat: HeartbeatData;
  activeDaemonTriggers: { data: DaemonTrigger[]; meta: PaginationMeta };
  conventions: ConventionListItem[];
};

type RunnerRequestBootstrapEnvelope = {
  data: RunnerRequestBootstrap;
};

export const fetchRunnerRequestBootstrap = async (
  token: string,
  projectId: string,
): Promise<RunnerRequestBootstrap> => {
  const response = await fetchWithAuthRetry(`${getApiUrl()}/api/projects/${projectId}/runner-request/bootstrap`, {
    cache: 'no-store',
    headers: authHeaders(token),
  });

  if (!response.ok) {
    throw await parseApiError(response, `Failed to fetch runner request bootstrap: ${response.status}`);
  }

  const payload = (await response.json()) as RunnerRequestBootstrapEnvelope;
  return payload.data;
};
